export class EmailToThreadDto {
  jobId: string;
  emailId: string;
  userId: string;
}
